import { InformeTableDataDtoProps } from "./DTOs/InformeTableDataDto"

export const perdidasGananciasByFilterAdapter = (
  perdidasGanancias: InformeTableDataDtoProps
): InformeTableDataDtoProps => {
  return {
    items: perdidasGanancias?.items,
    tableColumns: perdidasGanancias?.tableColumns,
  }
}
